/**
 * Generic CSV export utility.
 * Derives headers from the union of keys of the first row.
 */

function escapeValue(value: string | number): string {
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportToCsv(
  filename: string,
  rows: Record<string, string | number>[]
): void {
  if (typeof document === 'undefined') return;
  if (rows.length === 0) return;

  const headers = Object.keys(rows[0]);
  const csvLines = [
    headers.map(escapeValue).join(','),
    ...rows.map((row) => headers.map((h) => escapeValue(row[h] ?? '')).join(',')),
  ];
  const csv = csvLines.join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
